import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { getGroupByUserList } from '../../../axios/User/UserApi';
import { toast } from 'react-toastify';
import { Box } from '@mui/system';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import { StyledDataGrid } from '../../../components/StyledComponents';
import CustomSpinner from '../../../components/CustomSpinner';
import { useAuth } from '../../../context/AuthContext';

const GroupManagement = (props) => {
    const { userId } = props;
    const { t, i18n } = useTranslation();
    const { profile, isAdmin } = useAuth()

    const [groupByUser, setGroupByUserData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Admin: user đang chọn; Employee: luôn lấy từ profile (selectedRow thường rỗng)
    const targetUserId = isAdmin ? userId : profile?.userId;

    const fetchGroupByUserData = async () => {
        if (!targetUserId) return;

        const payload = {
            langId: localStorage.getItem("i18nextLngId"),
            userId: targetUserId,
        };

        setLoading(true);

        try {
            const response = await getGroupByUserList(payload);
            if (
                response?.data?.message === "Successful" ||
                response?.data?.message === "Thành công"
            ) {
                setGroupByUserData(
                    response.data.data
                );
            }
        } catch (error) {
            if (error?.response && error.response.status !== 401) {
                toast.error(error?.response?.data?.message || "Error");
            } else {
                toast.error(t('common.network-timeout'));
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroupByUserData();
    }, [targetUserId]);

    const columns = useMemo(
        () => [
            {
                field: "groupName",
                headerName: t("common.group-name"),
                flex: 1.2,
                valueFormatter: (value) => {
                    if (!value) return "-";

                    const normalized = String(value).trim().toLowerCase();

                    if (normalized === "all users") return t("common.all-user");

                    return value;
                }
            },

            {
                field: "remark",
                headerName: t("common.description"),
                flex: 1,
                valueFormatter: (value) => {
                    if (!value) return "-";

                    const normalized = String(value).trim().toLowerCase();

                    if (normalized === "default group for all users")
                        return t("common.default-group-for-all-users");

                    return value;
                }
            },
        ],
        [t, i18n.language]
    );

    return (
        <Box className="relative flex flex-col gap-4" sx={{ minHeight: "70.5vh" }}>
            <CustomSpinner loading={loading} />
            <StyledDataGrid
                rows={groupByUser}
                getRowId={(row) => row.id}
                columns={columns}
                hideFooter
                disableRowSelectionOnClick
                columnHeaderHeight={44}
                rowHeight={48}
                slots={{
                    // pagination: CustomPagination,
                    noRowsOverlay: NoRowOverlay,
                    columnsPanel: CustomColumnsPanel,
                }}
                sx={{
                    height: 'auto',

                    ...(groupByUser.length === 0 && {
                        "& .MuiDataGrid-virtualScroller": {
                            overflow: "hidden !important",
                        },
                    }),

                    "@media (max-width: 1919px)": {
                        height: 'auto',
                    },

                    ".MuiDataGrid-main": {
                        height: "70.5vh",
                    },

                    "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
                    {
                        display: "none !important",
                    },

                    "& .MuiDataGrid-scrollbarFiller": {
                        display: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        paddingRight: 0,
                    },
                    "& .MuiDataGrid-topContainer": {
                        paddingRight: 0,
                    },

                    "&": {
                        "--DataGrid-scrollbarSize": "0px",
                    },

                    "& .MuiDataGrid-virtualScroller": {
                        scrollbarWidth: "none",
                    },
                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                        width: 0,
                        height: 0,
                    },
                    "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
                    {
                        scrollbarWidth: "thin",
                    },
                    "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
                    {
                        width: 10,
                        height: 10,
                    },

                    '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
                        display: "none !important",
                    },

                    "& input[type=number]::-webkit-inner-spin-button, \
             & input[type=number]::-webkit-outer-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                    },

                    "& input[type=number]": {
                        textAlign: "center",
                        MozAppearance: "textfield",
                        WebkitAppearance: "none",
                        padding: "5px !important",
                        height: "100%",
                        pointerEvents: "none",
                        caretColor: "transparent",
                        userSelect: "none",
                        paddingTop: "8px !important",
                        paddingBottom: "8px !important"
                    },
                }}
            />
        </Box>
    )
}

export default GroupManagement
